module.exports = __webpack_public_path__ + "static/media/logonew.c5fa4271.svg";